import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ViewsHomeContentOurTeamService {
  isVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  unsubscribe$: Subject<any> = new Subject<any>();

  constructor() { }

  unsubscribeVisible(): void {
    // @ts-ignore //Todo check error
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
